// extracted by mini-css-extract-plugin
module.exports = {"faqlink_container":"FaqLink_faqlink_container__GzfGa","faqlink_img":"FaqLink_faqlink_img__2UKiR","faqlink_title":"FaqLink_faqlink_title__eP7UK"};